// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content049_wrapper__DFUW2"};